import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "instant"
const InstantIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.016 1.813C17.549 1.287 18.477 1.755 18.338 2.52L17.004 9.854 22.149 10.497C22.772 10.575 23.057 11.315 22.65 11.791L13.785 22.133C13.262 22.743 12.268 22.27 12.412 21.48L13.745 14.146 8.601 13.503C7.978 13.425 7.693 12.685 8.1 12.21L16.965 1.867zM10.102 12.179 15.505 12.854 14.358 19.16 20.648 11.82 15.245 11.146 16.392 4.841z"
            clipRule="evenodd"
          />
          <path d="M9.75 16.875C9.75 17.703 9.078 18.375 8.25 18.375H3V16.875zM6.75 11.25C6.75 12.08 6.078 12.75 5.25 12.75H1.5V11.25zM9.75 5.625C9.75 6.454 9.078 7.125 8.25 7.125H3V5.625z" />
        </svg>
      }
    </span>
  )
}
export default InstantIcon
